import { get } from "./requests";
import { URL_BASE } from "./constants";
import { Store } from "../redux/store";
import { loadLocalization } from "../redux/actions/localizationActions";

export async function getAllLocalizations() {
    const locationsPayload = await get(`${URL_BASE}/localizations/states/cities`);
    Store.dispatch(loadLocalization(locationsPayload.data));
    return locationsPayload.data;
}